<template>
  <b-modal
      id="confirm-delete"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      centered
      v-model="modalShow"
  >
    <header class="d-flex flex-column align-items-center justify-center-center my-2">
      <feather-icon
          id="view-departamento"
          icon="AlertCircleIcon"
          :class="'text-warning mb-2'"
          size="80"
      />
      <h2>Atenção!</h2>
    </header>

    <main>
      <p>Esta vacina já possui registros de vacinação!</p>

      <p>
        A vacina que você está editando já foi utilizada em um ou mais registros de vacinação.
        Salvar as alterações poderá impactar a consistência dos dados históricos e afetar a
        exibição de informações não apenas nos módulos e relatórios, mas também em demais dados
        do sistema que possuem correlação direta com a vacina, incluindo:
      </p>

      <ul>
        <li>Doenças (Cadastro, Edição e Visualização)</li>
        <li>Campanhas Regionais (Cadastro, Edição e Visualização)</li>
        <li>Campanhas Nacionais (Cadastro, Edição e Visualização)</li>
        <li>Adesão Nacional e Regional</li>
        <li>Estoque Físico (Dashboard e Filtros)</li>
        <li>Entrada de Lote (NF-e)</li>
        <li>Transferência de Estoque</li>
        <li>Ajuste de Estoque</li>
        <li>Lote (Cadastro e Filtro)</li>
        <li>Registro de Vacinados (Filtros e Histórico)</li>
        <li>Relatórios (Colaboradores Vacinados, Exportação SMD)</li>
        <li>Painéis SESI e Empresa</li>
        <li>Integrações RNDS</li>
      </ul>

      <p>Você confirma que deseja aplicar estas alterações, cliente dos impactos?</p>

      <label>
        <b-form-checkbox v-model="isConfirmed">
          Declaro que li e estou ciente dos impactos desta alteração.
        </b-form-checkbox>
      </label>
    </main>

    <footer>
      <div class="d-flex justify-content-center my-2">
        <b-button :disabled="loading || !isConfirmed" variant="primary-button" @click="confirmAction">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Continuar
        </b-button>

        <b-button :disabled="loading" variant="outline-primary" class="ml-1" @click="cancelAction">
          Cancelar
        </b-button>
      </div>
    </footer>
  </b-modal>
</template>

<script>
import {BModal, BButton, BFormCheckbox} from 'bootstrap-vue';

export default {
  name: 'ModalConfirmacaoImpactoAlteracao',

  components: {
    BFormCheckbox,
    BModal, BButton
  },

  props: {
    modalShow: {
      required: true,
      type: Boolean
    },
  },

  data() {
    return {
      loading: false,
      textButtonCancel: '',
      infoTextModal: '',
      isConfirmed: false,
    }
  },

  methods: {
    confirmAction(modalEvent) {
      modalEvent.preventDefault();
      this.loading = true;
      this.$emit('confirmed', modalEvent);
    },

    cancelAction(modalEvent) {
      modalEvent.preventDefault();
      this.$emit('canceled', modalEvent);
    },
  },

  watch: {
    modalShow() {
      this.loading = false;
    }
  },
}
</script>

